import React, { useEffect, useMemo } from "react";
import { useFeaturedContentFeedQuery } from "../../generated/gateway-client";
import { CardSwiper } from "../CardSwiper";
import { EventCard } from "../events/EventCard";
import { NewsCard } from "../news/NewsCard";

interface Props {
  className?: string;
  title: string;
  onLoading?: (args: { loading: boolean; hasContent: boolean }) => void;
  show: boolean;
  metric?: { ns: string; nx: number };
}

export const FeaturedContentCardSwiper: React.FC<Props> = ({
  className,
  title,
  show,
  onLoading = (_args) => undefined,
  metric,
}) => {
  const { called, loading, data } = useFeaturedContentFeedQuery({
    notifyOnNetworkStatusChange: true,
  });

  const content = data?.featuredContentFeed.edges ?? [];
  const cards = useMemo(
    () => content.flatMap((edge, i) => {
      switch (edge.__typename) {
        case "NewsEdge":
          return edge.node != null ? [<NewsCard key={i} className="swiper-slide" newsPost={edge.node} metric={metric} />] : [];
        case "EventOccurrenceEdge":
          return edge.node != null ? [<EventCard key={i} className="swiper-slide" occurrence={edge.node} metric={metric} />] : [];
      }

      return [];
    }),
    [content],
  );

  useEffect(() => {
    if (called && !loading) {
      onLoading({ loading, hasContent: cards.length > 0 });
    }
  }, [cards, called, loading]);

  return !show ? null : (
    <CardSwiper
      title={title}
      breakpoints={{
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4,
      }}
      loading={loading}
      className={className}
    >{{ cards }}</CardSwiper>
  );
};
